import { injectGlobal } from 'styled-components';
import { textColour } from './colors';

const ASSET_PATH = process.env.NODE_ENV == 'development' ? '' : '/';

injectGlobal`
    body {
        /* font-family: 'Suisse', 'Arial', 'Helvetica', serif; */
        font-family: 'Suisse', serif;
        -webkit-font-smoothing: antialiased;
        color: ${textColour};
    }

    input {
        font-family: 'Suisse', serif;
    }

    @font-face {
        font-family: 'Suisse';
        src: url(${ASSET_PATH}${require('../assets/fonts/SuisseIntl-Regular.woff2')});
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Suisse';
        src: url(${ASSET_PATH}${require('../assets/fonts/SuisseIntlSemiBold.woff2')});
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Suisse Mono';
        src: url(${ASSET_PATH}${require('../assets/fonts/SuisseIntlMono-Regular.woff2')});
        font-style: normal;
        font-weight: normal;
    }

`



// WEBPACK FOOTER //
// ./client/styles/fonts.js